module.exports = __webpack_public_path__ + "static/media/white-logo.770de6b7.png";